import React from 'react'
import { PageProps, graphql } from 'gatsby'
import { BuilderComponent, builder } from '@builder.io/react'
import { BuilderIoContentResponse, PageModel, BlogPageModel } from '../types/builderio-models'
import SEO from '../components/Seo/seo'

builder.init(process.env.GATSBY_BUILDER_PUBLIC_KEY!)
const isDevEnv = process.env.NODE_ENV === 'development'

interface IndexProps {
  allBuilderModels: {
    onePage: {
      content: BuilderIoContentResponse<PageModel, 'page'>
    }
    oneArchive: {
      data: {
        slug: string
      }
    }
    latestBlogs: {
      content: BuilderIoContentResponse<BlogPageModel, 'page'>
    }[]
  }
}

const Index = ({ data }: PageProps<IndexProps>) => {
  const { url, documentMeta } = data.allBuilderModels.onePage.content.data
  const { slug: archiveUrl } = data.allBuilderModels.oneArchive.data
  const { latestBlogs } = data.allBuilderModels

  return (
    <>
      <SEO
        title={documentMeta.value.data.title}
        description={documentMeta.value.data.description}
        openGraphImage={documentMeta.value.data.openGraphImage}
        twitterCardImage={documentMeta.value.data.twitterCardImage}
        slug={url}
      />
      <BuilderComponent
        model="page"
        content={data.allBuilderModels.onePage.content}
        options={{
          enrich: true,
          includeUnpublished: isDevEnv,
          cachebust: isDevEnv,
          cache: !isDevEnv,
        }}
        data={{
          archiveUrl: `/${archiveUrl}/`,
          latestBlogs,
        }}
        contentLoaded={(_, content) => {
          if (!content) {
            console.error('No content found')
          }
        }}
      />
    </>
  )
}

export const pageQuery = graphql`
  query ($path: String!, $environment: String) {
    allBuilderModels {
      onePage(
        target: { urlPath: $path }
        query: { data: { environment: $environment } }
        options: { cachebust: true, enrich: true }
      ) {
        content
      }
      oneArchive {
        data {
          slug
        }
      }
      latestBlogs: blogPost(
        sort: { data: { publishedAt: -1 } }
        query: { data: { environment: $environment } }
        limit: 3
        options: { cachebust: true, enrich: true }
      ) {
        content
      }
    }
  }
`
export default Index
